// Dashboard service — fetches admin metrics from the backend
import { fetchWithAuth } from '@startus/lib';
import type { AdminMetrics } from '../types/dashboard';

const API_BASE_URL = import.meta.env.VITE_API_URL;

if (!API_BASE_URL) {
  throw new Error('VITE_API_URL is not defined');
}

/** Fetches all admin dashboard metrics from GET /api/v1/admin/metrics */
export const fetchDashboardData = async (): Promise<AdminMetrics> => {
  const response = await fetchWithAuth(`${API_BASE_URL}/api/v1/admin/metrics`, {
    headers: { 'Content-Type': 'application/json' },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch admin metrics: ${response.status}`);
  }

  // API wraps response in { success, data, meta } via TransformInterceptor
  const body = (await response.json()) as { data: AdminMetrics };
  return body.data;
};
